import { Avatar, Menu } from '@inexture/core';
import { BsPerson } from 'react-icons/bs';
import { AiOutlineSetting } from 'react-icons/ai';
import { FaSignOutAlt } from 'react-icons/fa';
import { store, useAppSelector } from '@/store';
import { GET_AUTH_CONFIG, RESET_AUTH_TOKEN } from '@/store/app/auth.slice.ts';

const UserMenu = () => {
  const { user } = useAppSelector(GET_AUTH_CONFIG);
  return (
    <Menu width={150}>
      <Menu.Target>
        <Avatar
          styles={{ root: { cursor: 'pointer' } }}
          variant="light"
          bg="primary.5"
          color="white"
          size={45}
          radius="xl"
          component="div"
        >
          {user?.username?.charAt(0).toUpperCase()}
        </Avatar>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item leftSection={<BsPerson />}>Account</Menu.Item>
        <Menu.Item leftSection={<AiOutlineSetting />}>Settings</Menu.Item>
        <Menu.Divider />
        <Menu.Item
          onClick={() => store.dispatch(RESET_AUTH_TOKEN())}
          leftSection={<FaSignOutAlt />}
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default UserMenu;
